export default __webpack_public_path__ + "static/media/c-aws.894d0d54.jpg";